import React, { useState } from "react";
import "../Styles/ServiceC.css";
import serviceCardData from "../Data/ServiceCardData";
import { Link } from "react-router-dom";
function Service() {
  const [serviceData] = useState(serviceCardData);
  return (
    <div className="service_container margin_top_1001">
      <div className="scontainer">
        <div className="row service_content">
          <div data-aos="fade-down"
          // data-aos-duration="1500"
          data-aos-mirror="true"
          data-aos-once="false"
          data-aos-easing="ease-in-out" className="col-md-12">
            <p className="service_sub_title">Educational resources</p>
            <h1 className="service_title">Explore Loan Guides</h1>
            <p className="service_intro">
              Learn about eligibility, documentation, repayment planning and
              government-supported schemes. Always verify current rules with an
              official source.
            </p>
          </div>
        </div>
        <div className="row">
          {serviceCardData.map((serviceCardDetail) => {
            const { id, title, buttonText, img, slug } =
              serviceCardDetail;
            return (
              <div className="col-xl-3 col-md-6 col-sm-12" key={id}>
                <div data-aos="fade-right"
          // data-aos-duration="1500"
          data-aos-mirror="true"
          data-aos-once="false"
          data-aos-easing="ease-in-out" className="card">
                  <div className="circle">
                    <img src={img} alt="" />
                  </div>
                  <h2 className="service_card_title">{title}</h2>
                  <Link className="btn service_btn" to={`/service/${slug}`}>
                    {buttonText} &#8594;
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default Service;
